import React from 'react';
import { Redirect, useLocation } from "react-router";
import { getFullRoute } from '../../helper/navigationHelpers';
export const NavigateTo = ({
  to
}) => {
  const location = useLocation();
  return /*#__PURE__*/React.createElement(Redirect, {
    to: getFullRoute(to, location)
  });
};